(function ($, Drupal) {

  'use strict';

  Drupal.behaviors.paragraph_story = {
    attach: function (context, settings) {

      $(once('slick', '.paragraph--type--story.paragraph--view-mode--default .stories')).each(function () {
        $(this).find('.story__media').slick({
          adaptiveHeight: true,
          arrows: false,
          dots: false,
          infinite: false,
          swipe: false,
        });

        $(this).find('.story__content').slick({
          adaptiveHeight: true,
          arrows: true,
          fade: true,
          infinite: false,
          swipe: false,
          prevArrow: $(this).find('.prev'),
          nextArrow: $(this).find('.next'),
        }).on('beforeChange', function(event, slick, currentSlide, nextSlide){
          $(this).parents('.paragraph--type--story').find('.story__media').slick('slickGoTo', nextSlide);
        });

      })

    }
  };

})(jQuery, Drupal);
